import { Checkbox } from '@hub-la/shadcn'
import { ColumnDef } from '@tanstack/react-table'
import moment from 'moment'
import { Subscription } from '../../../domain/dtos/subscription'
import { SubscriptionStatus } from '../../../domain/enums/subscription-status'
import { DataTableColumnHeader } from '../../components/data-table-column-header'
import { SubscriptionStatusStats } from '../../components/subscription-status-stats'

export const columns: ColumnDef<Subscription>[] = [
  {
    id: 'select',
    header: ({ table }) => (
      <div className="h-8 flex flex-col items-center justify-center">
        <Checkbox
          checked={table.getIsAllPageRowsSelected()}
          onCheckedChange={(value) => table.toggleAllPageRowsSelected(!!value)}
          aria-label="Select all"
        />
      </div>
    ),
    cell: ({ row }) => (
      <div className="h-8 flex flex-col items-center justify-center">
        <Checkbox
          checked={row.getIsSelected()}
          onCheckedChange={(value) => row.toggleSelected(!!value)}
          aria-label="Select row"
          onClick={(e) => e.stopPropagation()}
        />
      </div>
    ),
    enableSorting: false,
    enableHiding: false,
  },
  {
    accessorKey: 'payer.identity.fullName',
    header: 'Cliente',
  },
  {
    accessorKey: 'status',
    header: 'Status',
    cell: ({ row }) => {
      const status: SubscriptionStatus = row.getValue('status')

      return <SubscriptionStatusStats status={status} />
    },
  },
  {
    accessorKey: 'id',
    header: 'ID da assinatura',
  },
  {
    accessorKey: 'items',
    header: 'Produto',
    cell: ({ row }) => {
      const items: Pick<Subscription, 'items'> = row.getValue('items')

      if (!items) {
        return null
      }

      return <>{items[0].productName}</>
    },
  },
  {
    accessorKey: 'createdAt',
    header: ({ column }) => <DataTableColumnHeader column={column} title="Data da criação" />,
    cell: ({ row }) => {
      const createdAt: string = row.getValue('createdAt')

      if (!createdAt) {
        return null
      }

      return <>{moment(createdAt).format('D MMM. YYYY')}</>
    },
  },
  {
    accessorKey: 'nextDueAt',
    header: ({ column }) => <DataTableColumnHeader column={column} title="Data de vencimento" />,
    cell: ({ row }) => {
      const nextDueAt: string = row.getValue('nextDueAt')

      if (!nextDueAt) {
        return <>-</>
      }

      return <>{moment(nextDueAt).format('D MMM. YYYY')}</>
    },
  },
]
